import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { resolveTenantAppCode } from 'app/shared/api/tenant-api.context';

function resolveApiHost(): string {
    const configured = `${environment.endpoints?.api || ''}`.trim().toLowerCase();
    if (typeof window !== 'undefined') {
        const host = (window.location.hostname || '').toLowerCase();
        if (host.endsWith('.ashcorp.co') && configured.includes('ashcorp.xyz')) {
            return 'api.ashcorp.co';
        }
    }

    return configured.replace(/^https?:\/\//, '');
}

@Injectable()
export class ApiRequestInterceptor implements HttpInterceptor {

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Only add app parameter to requests going to our API
        if (req.url.includes('/api/') && !/^https?:\/\//i.test(req.url)) {
            const targetApiUrl = `https://${resolveApiHost()}${req.url}`;
            let modifiedReq = req.clone({ url: targetApiUrl });

            const appCode = resolveTenantAppCode();
            const token = environment.user?.token;
            const organization = environment.selection?.organization?.code;
            const branch = environment.selection?.branch?.code;

            const isSignIn = modifiedReq.url.includes('/api/authentication/sign-in');

            if (appCode) {
                modifiedReq = modifiedReq.clone({ setHeaders: { 'X-APP-CODE': appCode } });
            }
            if (organization) {
                modifiedReq = modifiedReq.clone({ setHeaders: { 'X-ORGANIZATION-CODE': organization } });
            }
            if (branch) {
                modifiedReq = modifiedReq.clone({ setHeaders: { 'X-BRANCH-CODE': branch } });
            }
            if (token && token !== 'undefined' && !isSignIn) {
                const bearerToken = token.startsWith('Bearer ') ? token : `Bearer ${token}`;
                modifiedReq = modifiedReq.clone({
                    setHeaders: {
                        'Authorization': bearerToken
                    }
                });
            }

            // Clone the request and add the app parameter to the body
            if (req.method === 'POST' || req.method === 'PUT' || req.method === 'PATCH') {
                const body = modifiedReq.body;

                if (body instanceof FormData) {
                    const modifiedFormData = new FormData();
                    body.forEach((value, key) => {
                        modifiedFormData.append(key, value);
                    });

                    modifiedReq = modifiedReq.clone({
                        body: modifiedFormData
                    });
                } else {
                    const normalizedBody = body && typeof body === 'object' ? body : {};
                    const modifiedBody = {
                        ...normalizedBody
                    };

                    modifiedReq = modifiedReq.clone({
                        body: modifiedBody
                    });
                }

                return next.handle(modifiedReq);
            }

            // For GET requests, add app as a query parameter
            if (req.method === 'GET' && appCode) {
                modifiedReq = modifiedReq.clone({
                    setParams: {
                        app: appCode
                    }
                });

                return next.handle(modifiedReq);
            }

            return next.handle(modifiedReq);
        }

        return next.handle(req);
    }
}
